import React, {
  type ComponentProps,
  type ComponentType,
  createElement,
  type ReactNode,
} from "react";

interface WrapIfProps<
  T extends keyof React.JSX.IntrinsicElements | ComponentType<any>,
> {
  condition: boolean;
  With: T;
  children: ReactNode;
}

type WrapIfComponent = {
  <T extends keyof React.JSX.IntrinsicElements | ComponentType<any>>(
    props: WrapIfProps<T> &
      (T extends keyof React.JSX.IntrinsicElements
        ? React.JSX.IntrinsicElements[T]
        : ComponentProps<T>)
  ): ReactNode;
  displayName?: string;
};

const WrapIf: WrapIfComponent = ({ condition, With, children, ref, ...rest }) => {
  if (typeof With === "string") {
    return condition ? createElement(With, { ...rest, ref }, children) : children;
  } else {
    // 'With' is a React component
    return condition ? (
      <With {...rest} ref={ref}>
        {children}
      </With>
    ) : (
      children
    );
  }
};

export default WrapIf;
